<section class="flex flex-col m-2.5 grow">
    <app-management-list-header
        [asAction]="false"
        [asSearch]="false"
        [title]="'fieldIntervention' | transloco" />

    <ul class="p-0 grid grid-cols-2 grow">
        @if (paginatedData()) {
            <li
                class="p-2 flex flex-row items-center cursor-pointer gap-1 hover:text-custom-blue hover:bg-custom-light-blue"
                (click)="toggleSelect.emit({ all: true })">
                <app-checkbox [checkboxState]="allSelected() ? CheckboxState.CHECKED : CheckboxState.UNCHECKED" />
                <p class="!m-0">{{ 'selectAll' | transloco }}</p>
            </li>
            @for (fieldIntervention of paginatedData()!.items; track fieldIntervention.id) {
                <li
                    class="p-2 flex flex-row items-center cursor-pointer gap-1 hover:text-custom-blue hover:bg-custom-light-blue"
                    (click)="toggleSelect.emit({ all: false, id: fieldIntervention.id })">
                    <app-checkbox
                        [checkboxState]="
                            selectedItems().includes(fieldIntervention.id)
                                ? CheckboxState.CHECKED
                                : CheckboxState.UNCHECKED
                        " />
                    <p class="!m-0">
                        {{ fieldIntervention.name }}
                        <span class="text-custom-dark-grey italic"
                            >({{ getProjectNameById(fieldIntervention.project) }})</span
                        >
                    </p>
                </li>
            }
        } @else {
            <app-loading />
        }
    </ul>

    <app-paginator
        #paginator
        [take]="paginatedData()!.take"
        [totalItems]="paginatedData()!.totalItems"
        (onPageChange)="onPaginationChange($event)" />
</section>
